import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5cb295e8")

_pushScopeId("data-v-5cb295e8")
const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "unit" }
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_my_card_body = _resolveComponent("my-card-body")
  const _component_my_card = _resolveComponent("my-card")

  return (_openBlock(), _createBlock(_component_my_card, { class: "mt-4" }, {
    header: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_ctx.$t("soberAnalyse.awakeningFrequency")) + " ", 1 /* TEXT */),
        _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("soberAnalyse.unit")), 1)
      ])
    ]),
    default: _withId(() => [
      _createVNode(_component_my_card_body, { class: "px-4" }, {
        default: _withId(() => [
          _createVNode("div", {
            ref: $setup.setRef,
            style: {"height":"60vw","width":"100%"}
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})